export default "__VITE_ASSET__d796aaf7__"